import { Route, Routes } from 'react-router-dom'

import { AdminAuthGuard } from './components/AdminAuthGuard'
import { AdminLayout } from './components/AdminLayout'
import { DefaultRoute } from './components/DefaultRoute'
import AdminAccountsPage from './pages/AdminAccountsPage'
import AdminDashboardPage from './pages/AdminDashboardPage'
import AdminDiscountsPage from './pages/AdminDiscountsPage'
import AdminLoginPage from './pages/AdminLoginPage'
import AdminProfilePage from './pages/AdminProfilePage'
import AdminShopsPage from './pages/AdminShopsPage'
import AdminTestStoresPage from './pages/AdminTestStoresPage'
import { AdminAuthProvider } from './providers/AdminAuthProvider'
import { FirebaseProvider } from './providers/FirebaseProvider'
import { SidebarProvider } from './providers/SidebarProvider'

function App() {
  return (
    <FirebaseProvider>
      <AdminAuthProvider>
        <SidebarProvider>
          <Routes>
            <Route path="/login" element={<AdminLoginPage />} />
            <Route
              path="/*"
              element={
                <AdminAuthGuard>
                  <AdminLayout>
                    <Routes>
                      <Route path="/" element={<DefaultRoute />} />
                      <Route
                        path="/dashboard"
                        element={
                          <AdminAuthGuard requiredPermission="view_dashboard">
                            <AdminDashboardPage />
                          </AdminAuthGuard>
                        }
                      />
                      <Route
                        path="/shops"
                        element={
                          <AdminAuthGuard requiredPermission="view_shops">
                            <AdminShopsPage />
                          </AdminAuthGuard>
                        }
                      />
                      <Route
                        path="/test-stores"
                        element={
                          <AdminAuthGuard requiredPermission="view_shops">
                            <AdminTestStoresPage />
                          </AdminAuthGuard>
                        }
                      />
                      <Route
                        path="/discounts"
                        element={
                          <AdminAuthGuard requiredPermission="view_shops">
                            <AdminDiscountsPage />
                          </AdminAuthGuard>
                        }
                      />
                      <Route
                        path="/accounts"
                        element={
                          <AdminAuthGuard requiredPermission="view_admin">
                            <AdminAccountsPage />
                          </AdminAuthGuard>
                        }
                      />
                      <Route path="/profile" element={<AdminProfilePage />} />
                    </Routes>
                  </AdminLayout>
                </AdminAuthGuard>
              }
            />
          </Routes>
        </SidebarProvider>
      </AdminAuthProvider>
    </FirebaseProvider>
  )
}

export default App
